import { render, staticRenderFns } from "./SettingPush.vue?vue&type=template&id=bf3e894e&"
import script from "./SettingPush.vue?vue&type=script&lang=ts&"
export * from "./SettingPush.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports